import { useCareTeam, useIsPartOfCareTeam } from 'shared/features/care-team';
import { useHasAppointmentWithMember } from 'shared/hooks';
export var useCanIAllOrMine = function (memberId, canIAll, canIMine) {
    // return early, no need to continue to hooks if can edit all or none
    if (canIAll) {
        return { canI: true, isFetched: true, isLoading: false, isError: false };
    }
    if (!canIMine) {
        return { canI: false, isFetched: true, isLoading: false, isError: false };
    }
    var _a = useHasAppointmentWithMember(memberId), hasAppointmentsWithMember = _a.data, appointmentsLoading = _a.isLoading, appointmentsError = _a.isError, appointmentsFetched = _a.isFetched;
    var _b = useCareTeam(memberId), memberCareTeam = _b.data, careTeamLoading = _b.isLoading, careTeamError = _b.isError, careTeamFetched = _b.isFetched;
    var isPartOfCareTeam = useIsPartOfCareTeam(memberCareTeam);
    return {
        canI: hasAppointmentsWithMember || isPartOfCareTeam,
        isLoading: appointmentsLoading || careTeamLoading,
        isError: careTeamError || appointmentsError,
        isFetched: careTeamFetched || appointmentsFetched,
    };
};
